import { gql } from "@apollo/client";

export const GET_HOME_BANNERS = gql`
  query homeBanners {
    sliderdata {
      banner_id
      banner_title
      banner_type
      banner_image
      banner_image_mobile
      banner_video
      banner_video_thumb_image
      label_button_text
      call_to_action
    }
  }
`;

export default {
  getHomeBannersQuery: GET_HOME_BANNERS,
};
